import { Badge } from 'slab'

import { type EnrollmentStatus, type SubmissionMethod } from './types'
import { assertUnreachable, snakeToSentenceCase } from '../../utils'

export default function EnrollmentStatusPill ({
  status,
  submissionMethod,
  removeManualSubmissionPrefix = false,
}: {
  status: EnrollmentStatus | undefined,
  submissionMethod: SubmissionMethod | undefined,
  removeManualSubmissionPrefix?: boolean,
}) {
  const cleanStatus = removeManualSubmissionPrefix ? status?.replace(/^manual_submission_/, '') : status
  const displayStatus = cleanStatus ? snakeToSentenceCase(cleanStatus) : 'Status unknown'

  return (
    <Badge
      type={getBadgeType(status, submissionMethod)}
    >
      {displayStatus}
    </Badge>
  )
}

function getBadgeType (status: EnrollmentStatus | undefined, submissionMethod: SubmissionMethod | undefined) {
  switch (status) {
    case 'member_confirmed':
      if (submissionMethod === 'manual') {
        return 'caution'
      } else {
        return 'neutral'
      }
    case 'manual_submission_in_progress':
    case 'binder_payment_required':
    case 'autopay_setup_required':
      return 'caution'
    case 'manual_submission_awaiting_general_agent':
    case 'manual_submission_awaiting_member':
      return 'info'
    case 'manual_submission_blocked':
    case 'canceled':
      return 'critical'
    case 'completed':
      return 'success'
    case 'in_member_cart':
    case 'submission_processing':
    case 'carrier_processing':
    case undefined:
      return 'neutral'
    default:
      assertUnreachable(status)
  }
}
